<template>
  <div class="page-bg">
    <!-- Header -->
    <Header
      :headerTitle="$t('m.orderDetails.title')"
      :hasBackBtn="true"
      :rightIconSrc="require('../../assets/img/dianhua.png')"
      :onRightBtnClick="call"
      :iconShow="true"
    ></Header>

    <div class="main-container">
      <!-- section orderList-->
      <section>
        <div class="cardId panel">
          <!--判断 status -->
          <h6>{{result.licenseplate}}</h6>
          <h6 v-if="result.status==4" style="float:right;color:#666;">{{$t('m.orderDetails.status4')}}</h6>
          <h6 v-if="result.status==6" style="float:right;color:#008aac;">{{$t('m.orderDetails.status6')}}</h6>
          <h6 v-if="result.status==7" style="float:right;color:#c30808;">{{$t('m.orderDetails.status7')}}</h6>
          <h6 v-if="result.status==8" style="float:right;color:#c30808;">{{$t('m.orderDetails.status8')}}</h6>
          <h6 v-if="result.status==9" style="float:right;color:#c30808;">{{$t('m.orderDetails.status9')}}</h6>
        </div>
        <div class="cardAddress panel"  style="margin-top:10px">
          <h6>{{$i18n.locale==='zh_CN' ? result.parkingName : result.parkingEnName}}</h6>
          <p style="width:100%;font-size:11px;">{{$i18n.locale==='zh_CN'? result.parkingAddress:result.parkingEnAddress}}</p>
        </div>


        <div class="cell-row" style="margin-top:8px">
          <van-cell :title="$t('m.orderDetails.orderNumber')" :value="result.orderNo" size="large" />
          <van-cell v-if="result.status!=4 && result.status!=7" :title="$t('m.orderDetails.actualInTime')" :value="result.actualInTime" size="large" />
          <van-cell v-if="result.status==4 || result.status==7" :title="$t('m.orderDetails.reservedInTime')" :value="result.appointInTime" size="large" />
        
          <van-cell v-if="result.status!=4 && result.status!=7" :title="$t('m.orderDetails.actualOutTime')" :value="result.actualOutTime" size="large" />
          <van-cell  v-if="result.status==4 || result.status==7" :title="$t('m.orderDetails.reservedOutTime')" :value="result.appointOutTime" size="large" />
          
          <van-cell  :title="$t('m.orderDetails.hoursAndMoeny')" :value="(result.appointTime/60+$t('m.orderDetails.hours')+' | '+(result.amount?result.amount:0)+$t('m.orderDetails.CNY'))" size="large" />
         
          <van-cell v-if="result.backRefundStatus==2"  :title="$t('m.orderDetails.refundAmount')" :value="result.backRefundAmount+$t('m.orderDetails.CNY')" size="large" />
         
          <van-cell v-if="result.timeoutTime && result.timeoutTime > 0"  :title="'超时支付'" :value="`超时${(result.timeoutTime/60).toFixed(2)}小时 | ${result.timeoutAmount}元`" size="large" />
      
          <van-cell v-if="result.chargeDuration && result.chargeDuration > 0" title="充电时长与度数" :value="`${(result.chargeDuration/60).toFixed(2)}小时 | ${result.chargeDegree}度`" size="large" />
         
          <van-cell v-if="result.chargeDuration && result.chargeDuration > 0" title="充电费用" :value="`${ result.chargeAmount}`" size="large" />
         
          <van-cell v-if="result.extraPayStatus==3" :title="$t('m.orderDetails.overpayment')" :value="`${result.extraPayAmount}${$t('m.orderDetails.CNY')}`" size="large" />
        
          <van-cell  v-if="result.status!=4 && result.status!=7" :title="$t('m.orderDetails.actualPay')" :value="`${result.settlementAmount} ${$t('m.orderDetails.CNY')}`" size="large" />
          <van-cell  v-if="result.status==4 || result.status==7" :title="$t('m.orderDetails.actualPay')" :value="`${result.deductionAmount} ${$t('m.orderDetails.CNY')}`" size="large" />
       
        </div>
       
      </section>
      <!-- footer -->
      <footer  class="footer-bg"  v-if="result.status==6">
        <b-btn v-b-modal.modal-center @click="complaint()">{{$t('m.orderDetails.complaintTitle')}}</b-btn>
        <b-btn
          v-b-modal.modal-center
          @click="invoicingInfo()"
          class="invoicingInfoKey"
          v-if="result.invoiced == 2"
        >{{$t('m.orderDetails.invoicesTitle')}}</b-btn>
      </footer>
    </div>
    <b-modal
      ref="myModalRef"
      id="messageBox"
      centered
      :ok-title="$t('m.phone.call')"
      :title="$t('m.phone.serviceTitle')"
      :cancel-title="$t('m.phone.cancel')"
      @ok="handleOk"
    >{{phone}}</b-modal>
    <!-- 提示信息 -->
    <Tip :message="message" :type="tipType" :show="tipShow"></Tip>
  </div>
</template>
<script>
import { orderListByDetails } from "../../api/order.js";
export default {
  name: "OrderDetails",
  data() {
    return {
      orderId: "", //订单Id
      result: [], //数据
      phone: "400-115-0606", //电话
      message: "", //提示信息
      tipShow: "0", //是否提示
      tipType: "" //提示类型
    };
  },
  methods: {
    //加载数据
    loadOrderDetails: function() {
      orderListByDetails({ orderId: this.orderId }).then(
        response => {
          if (response.data.status == 200) {
            this.result = response.data.result;
          } else {
            this.tipShow = "1" + Math.random() * 1000;
            this.message = response.data.message;
            this.tipType = "warning";
          }
        },
        err => {
          reject(err);
        }
      );
    },
    //开发票操作
    invoicingInfo: function() {
      this.$router.push("/invoicing");
    },
    //我要投诉操作
    complaint: function() {
      this.$router.push("/complaint/" + this.orderId);
    },
    call() {
      this.$refs.myModalRef.show();
    },
    handleOk: function() {
      window.location.href = "tel:" + this.phone;
    }
  },
  //加载事件
  created() {
    this.orderId = this.$route.params.orderId; //订单Id
    this.loadOrderDetails();
  }
};
</script>
<style >
header,
section p {
  margin: 0 auto;
  padding: 0;
}
header {
  text-align: center;
  font-size: 19px;
  color: black;
  padding: 10px;
  padding-bottom: 5px;
}
header .return {
  display: inline-block;
  float: left;
  vertical-align: middle;
  font-size: 14px;
}
header .title {
  text-align: center;
}
header .imgIco {
  display: inline-block;
  float: right;
}
section {
  margin-bottom: 70px;
}
section .cardId {
  border-bottom: 2px solid #efefef;
  padding: 5px 0;
  text-align: left;
}
section .cardId h6 {
  display: inline-block;
}
section .cardAddress {
  padding: 10px 0;
  text-align: left;
  border-bottom: 2px solid #efefef;
}
section .cardAddress h6 {
  margin: 0 auto;
  padding: 0px;
}
section .cardAddress p {
  font-size: 13px;
  color: #666;
}

.money p {
  line-height: 26px;
  font-size: 13px;
  font-family: "BMWTypeGlobalPro-Light";
  color: #4a4a4a;
}
.money p span {
  font-size: 13px;
  color: #a7a7a7;
}
.orderNo {
  padding-top: 10px;
}
.orderNo p {
  text-align: left;
  font-size: 13px;
  color: #A1A1A1;
}
.orderNo p span {
  font-size: 12px;
  display: inline-block;
  padding-left: 30%;
}
footer .btn-secondary {
  width: 44%;
  margin-right: 2%;
  background-color: #fff;
  color: #666;
}
footer .invoicingInfoKey {
  /* margin-left: 2%; */
  /* width: 44%; */
  margin-right: 0px;
  background-color: #0061B1;
  color: #fff;
}
</style>


